enum TopPlatformMovementType {
	ENTRY,
	EXIT,
}

export default TopPlatformMovementType;
